var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownGraph01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1125 675",
    style: {
      enableBackground: "new 0 0 1125 675"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F42111;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.2,165.1c2.5-4,4.8-7.6,7.5-11.9c30.9,12.6,61.5,25.1,92.1,37.6c125.9,51.6,251.7,103.1,377.5,154.9 c7.5,3.1,13.8,3,21.3-0.1c52.2-21.7,104.6-42.8,156.8-64.4c7.3-3,13-2.8,20.2,0.8c126.8,64.3,253.8,128.2,380.7,192.3 c4.2,2.1,8.3,4.1,14.4,7.2c-3.8-19.9-7.2-38-10.9-57.5c4.2-1,8.5-2,13.8-3.2c5.5,28,10.8,55.1,16.3,83.6 c-27.8,5.5-55.1,10.9-83.5,16.5c-0.9-4.7-1.6-8.8-2.6-13.9c19.4-3.9,38.2-7.7,59.3-12c-5.2-2.9-8.2-4.7-11.2-6.2 C946.2,426,821.4,363.4,696.7,300.6c-6.3-3.2-11.5-3.5-18.1-0.7c-53.3,21.9-106.6,43.4-160.2,64.6c-4.8,1.9-11.5,2.3-16.2,0.4 c-158.8-65.2-317.4-130.8-476-196.3C24,167.6,21.8,166.4,19.2,165.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownGraph01);
export default __webpack_public_path__ + "static/media/arrow-down-graph-01.e9eb9e5762acb5b89b43b0381fb6771c.svg";
export { ForwardRef as ReactComponent };